import {
  BaseUniDriver,
  UniDriver,
} from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { BadgeSize, BadgeSkin, BadgeType } from './Badge.types';

export interface BadgeUniDriver extends BaseUniDriver {
  text: () => Promise<string>;
  getType: () => Promise<BadgeType>;
  getSkin: () => Promise<BadgeSkin>;
  getSize: () => Promise<BadgeSize>;
  isUppercase: () => Promise<boolean>;
  hasClickCursor: () => Promise<boolean>;
}

export const badgeUniDriverFactory = (base: UniDriver): BadgeUniDriver => ({
  ...baseUniDriverFactory(base),

  /**
   * Gets badge text
   */
  text: () => base.text(),

  /**
   * Gets badge type
   */
  getType: () => base.attr('data-type') as Promise<BadgeType>,

  /**
   * Gets badge type
   */
  getSkin: () => base.attr('data-skin') as Promise<BadgeSkin>,

  /**
   * Gets badge size
   */
  getSize: () => base.attr('data-size') as Promise<BadgeSize>,

  /**
   * Checks whether the text is uppercase
   */
  isUppercase: async () => (await base.attr('data-uppercase')) === 'true',

  /**
   * Checks whether badge is clickable
   */
  hasClickCursor: async () => (await base.attr('data-clickable')) === 'true',
});
